import {TemplateList} from "~/libs/constants/TemplateList"
import type StaticMenuItem from "~/libs/interfaces/StaticMenuItem"

export const MenuFooterMostInterestedConfig: Record<TemplateList, StaticMenuItem[]> = {
  [TemplateList.POGGERS]: [
    {
      name: 'Moje Psychologie',
      url: 'https://www.mojepsychologie.cz/',
      target: "_blank"
    },
    {
      name: 'Blesk Tlapky',
      url: 'https://tlapky.blesk.cz/',
      target: "_blank",
    },
    {
      name: 'Hráči na Blesku',
      url: 'https://www.blesk.cz/hraci',
      target: "_blank",
    },
    {
      name: 'INFO.cz',
      url: 'https://www.info.cz',
      target: "_blank",
    },
    {
      name: 'Kam na houby',
      url: 'https://www.blesk.cz/clanek/zpravy-pribehy/787361/kam-na-houby-aktualni-mapa-rustu-hub-v-cele-cr-zjistete-kde-rostou.html',
      target: "_blank",
    },
    {
      name: 'Děsivé pozadí Záhadných případů!',
      url: 'https://www.ahaonline.cz/clanek/zhave-drby/219019/desive-pozadi-zahadnych-pripadu-ze-slov-donutila-mrazi.html',
      target: "_blank",
    },
    {
      name: 'TV program na vánoce',
      url: 'https://www.blesk.cz/clanek/celebrity-serialy-filmy-kino-a-tv/758575/stahnete-si-kompletni-vanocni-tv-program-kdy-bude-popelka-pelisky-a-nove-pohadky.html',
      target: "_blank",
    },
    {
      name: 'Biatlon',
      url: 'https://sportovniprogram.cz/sp-v-biatlonu',
      target: "_blank",
    },
    {
      name: 'StarDance 2024',
      url: 'https://sportovniprogram.cz/stardance',
      target: "_blank",
    },
    {
      name: 'OKTAGON 64',
      url: 'https://sportovniprogram.cz/oktagon-64-program-kde-sledovat-zive',
      target: "_blank",
    },
  ],
  [TemplateList.MATERIDOUSKA]: [
    {
      name: 'Tipy a rady',
      url: 'https://mama.pigy.cz/category/tipy-rady',
      target: "_blank"
    },
    {
      name: 'Rádio pro děti',
      url: 'https://www.pigy.cz/radia/',
      target: "_blank",
    },
    {
      name: 'Podcasty pro rodiče',
      url: 'https://www.maminka.cz/tema/podcasty',
      target: "_blank",
    },
    {
      name: 'Mimibazar',
      url: 'https://www.mimibazar.cz/',
      target: "_blank",
    },
    {
      name: 'Tvoření',
      url: 'https://mama.pigy.cz/category/tvoreni/',
      target: "_blank",
    },
    {
      name: 'Na pohovoru zazáříte',
      url: 'https://muj.starjob.cz/cs',
      target: "_blank",
    },
    {
      name: 'Porod',
      url: 'https://www.maminka.cz/porod',
      target: "_blank",
    },
    {
      name: 'Pigy akce',
      url: 'https://www.pigy.cz/rubrika-novinek/akce/',
      target: "_blank",
    },
  ]
}